import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorage } from '@service/LocalStorage';
import { parse, stringifyUrl } from 'query-string';

interface CurrencyState {
  lead: { id?: number | string; name?: string; positionMode?: 'full' | 'sideBar' | 'modal'; open?: boolean };
  offsetTop: number;
  minimizedPipes: number[];
  setting: boolean;
  isNewCRM: boolean;
}

const initialState: CurrencyState = {
  lead: window.location.pathname.includes('crm')
    ? (LocalStorage.get<CurrencyState['lead']>('lead') as CurrencyState['lead']) || {}
    : {},
  setting: false,
  minimizedPipes: (LocalStorage.get<number[]>('minimizedPipes') as number[]) || [],
  offsetTop: 0,
  isNewCRM: Boolean(LocalStorage.get<boolean>('isNewCRM') as boolean) ?? false
};

export const crmV2Slice = createSlice({
  name: 'crmV2Slice',
  initialState,
  reducers: {
    setLead: (state, action: PayloadAction<{ separator?: boolean } & CurrencyState['lead']>) => {
      const { separator, ...props } = action.payload;

      const mode = state.lead?.positionMode || 'sideBar';
      const leadSaveButtons = document.querySelector('.leadSaveButtons');

      if (leadSaveButtons && state?.lead?.id !== 'new') {
        leadSaveButtons.classList.add('animate-bounce-x');
        setTimeout(() => {
          leadSaveButtons.classList.remove('animate-bounce-x');
        }, 300);
      } else if (separator) {
        state.lead = { ...state.lead, positionMode: mode, ...props };
        LocalStorage.set('lead', JSON.stringify({ ...state.lead, positionMode: mode, ...props }));
      } else {
        state.lead = { positionMode: mode, ...props };
        LocalStorage.set('lead', JSON.stringify({ positionMode: mode, ...props }));
      }

      if (window.location.pathname?.includes('crm') || window.location.pathname?.includes('task')) {
        const query: Record<string, any> = parse(window.location?.search);

        if (state.lead?.open && state.lead?.id) {
          query.leadId = state.lead?.id;
          query.leadName = state.lead?.name;
        } else {
          delete query?.leadId;
          delete query?.leadName;
        }

        window.history.replaceState(
          window.location.pathname,
          '',
          stringifyUrl({
            url: window.location.pathname,
            query
          })
        );
      }
    },
    setSetting: (state, action: PayloadAction<boolean>) => {
      state.setting = action.payload;
    },
    setMinimizedPipes: (state, action: PayloadAction<number>) => {
      if (state.minimizedPipes?.includes(action.payload)) {
        state.minimizedPipes = state.minimizedPipes?.filter(pipeId => pipeId !== action.payload);
      } else {
        state.minimizedPipes.push(action.payload);
      }

      LocalStorage.set('minimizedPipes', JSON.stringify(state.minimizedPipes));
    },
    setOffsetTop: (state, action: PayloadAction<number>) => {
      state.offsetTop = action.payload;
    },
    setNewCrm: (state, action: PayloadAction<boolean>) => {
      state.isNewCRM = action.payload;
      if (action.payload) {
        LocalStorage.set('isNewCRM', String(action.payload));
      } else {
        LocalStorage.remove('isNewCRM');
      }
    }
  }
});

export const { setLead, setSetting, setMinimizedPipes, setOffsetTop, setNewCrm } = crmV2Slice.actions;
export default crmV2Slice.reducer;
